/**
 * Service dédié aux appels API du formulaire de demande d'accès
 * (institution ou média). À connecter à l'API SecuFire.
 */

/**
 * Envoie une demande d'accès.
 * @param {{ userType: "institution" | "media", [key: string]: any }} formData
 * @returns {Promise<void>}
 */
export const submitAccessRequest = async (formData) => {
  // TODO : appel API réel à intégrer ici.
};

/**
 * Inscrit une adresse e-mail aux alertes/newsletter.
 * @param {{ email: string, zones: string }} newsletterData
 * @returns {Promise<void>}
 */
export const subscribeToAlerts = async (newsletterData) => {
  // TODO : appel API réel à intégrer ici.
};
